import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../wayfinder'
/**
* @see \App\Http\Controllers\FeatureController::__invoke
* @see app/Http/Controllers/FeatureController.php:9
* @route '/api/features'
*/
export const features = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: features.url(options),
    method: 'get',
})

features.definition = {
    methods: ["get","head"],
    url: '/api/features',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FeatureController::__invoke
* @see app/Http/Controllers/FeatureController.php:9
* @route '/api/features'
*/
features.url = (options?: RouteQueryOptions) => {
    return features.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\FeatureController::__invoke
* @see app/Http/Controllers/FeatureController.php:9
* @route '/api/features'
*/
features.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: features.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FeatureController::__invoke
* @see app/Http/Controllers/FeatureController.php:9
* @route '/api/features'
*/
features.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: features.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\DocumentTypeController::__invoke
* @see app/Http/Controllers/Api/DocumentTypeController.php:8
* @route '/api/document-types'
*/
export const documentTypes = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: documentTypes.url(options),
    method: 'get',
})

documentTypes.definition = {
    methods: ["get","head"],
    url: '/api/document-types',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\DocumentTypeController::__invoke
* @see app/Http/Controllers/Api/DocumentTypeController.php:8
* @route '/api/document-types'
*/
documentTypes.url = (options?: RouteQueryOptions) => {
    return documentTypes.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\DocumentTypeController::__invoke
* @see app/Http/Controllers/Api/DocumentTypeController.php:8
* @route '/api/document-types'
*/
documentTypes.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: documentTypes.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\DocumentTypeController::__invoke
* @see app/Http/Controllers/Api/DocumentTypeController.php:8
* @route '/api/document-types'
*/
documentTypes.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: documentTypes.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\PlatformStatisticsController::__invoke
* @see app/Http/Controllers/Api/PlatformStatisticsController.php:10
* @route '/api/platform-stats'
*/
export const platformStats = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: platformStats.url(options),
    method: 'get',
})

platformStats.definition = {
    methods: ["get","head"],
    url: '/api/platform-stats',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\PlatformStatisticsController::__invoke
* @see app/Http/Controllers/Api/PlatformStatisticsController.php:10
* @route '/api/platform-stats'
*/
platformStats.url = (options?: RouteQueryOptions) => {
    return platformStats.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\PlatformStatisticsController::__invoke
* @see app/Http/Controllers/Api/PlatformStatisticsController.php:10
* @route '/api/platform-stats'
*/
platformStats.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: platformStats.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\PlatformStatisticsController::__invoke
* @see app/Http/Controllers/Api/PlatformStatisticsController.php:10
* @route '/api/platform-stats'
*/
platformStats.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: platformStats.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::register
* @see app/Http/Controllers/Auth/RegisteredUserController.php:32
* @route '//app.finesthub.de/register'
*/
export const register = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

register.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/register',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::register
* @see app/Http/Controllers/Auth/RegisteredUserController.php:32
* @route '//app.finesthub.de/register'
*/
register.url = (options?: RouteQueryOptions) => {
    return register.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::register
* @see app/Http/Controllers/Auth/RegisteredUserController.php:32
* @route '//app.finesthub.de/register'
*/
register.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::register
* @see app/Http/Controllers/Auth/RegisteredUserController.php:32
* @route '//app.finesthub.de/register'
*/
register.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: register.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:22
* @route '//app.finesthub.de/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:22
* @route '//app.finesthub.de/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:22
* @route '//app.finesthub.de/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:22
* @route '//app.finesthub.de/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:52
* @route '//app.finesthub.de/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:52
* @route '//app.finesthub.de/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:52
* @route '//app.finesthub.de/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AttachmentController::download
* @see app/Http/Controllers/AttachmentController.php:116
* @route '/download/{attachment}'
*/
export const download = (args: { attachment: string | number | { id: string | number } } | [attachment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: download.url(args, options),
    method: 'get',
})

download.definition = {
    methods: ["get","head"],
    url: '/download/{attachment}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AttachmentController::download
* @see app/Http/Controllers/AttachmentController.php:116
* @route '/download/{attachment}'
*/
download.url = (args: { attachment: string | number | { id: string | number } } | [attachment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { attachment: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { attachment: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            attachment: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        attachment: typeof args.attachment === 'object'
        ? args.attachment.id
        : args.attachment,
    }

    return download.definition.url
            .replace('{attachment}', parsedArgs.attachment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AttachmentController::download
* @see app/Http/Controllers/AttachmentController.php:116
* @route '/download/{attachment}'
*/
download.get = (args: { attachment: string | number | { id: string | number } } | [attachment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: download.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AttachmentController::download
* @see app/Http/Controllers/AttachmentController.php:116
* @route '/download/{attachment}'
*/
download.head = (args: { attachment: string | number | { id: string | number } } | [attachment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: download.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AttachmentController::bulkDownload
* @see app/Http/Controllers/AttachmentController.php:133
* @route '/zip-download/{resourceType}/{resourceId}'
*/
export const bulkDownload = (args: { resourceType: string | number, resourceId: string | number } | [resourceType: string | number, resourceId: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bulkDownload.url(args, options),
    method: 'get',
})

bulkDownload.definition = {
    methods: ["get","head"],
    url: '/zip-download/{resourceType}/{resourceId}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AttachmentController::bulkDownload
* @see app/Http/Controllers/AttachmentController.php:133
* @route '/zip-download/{resourceType}/{resourceId}'
*/
bulkDownload.url = (args: { resourceType: string | number, resourceId: string | number } | [resourceType: string | number, resourceId: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            resourceType: args[0],
            resourceId: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        resourceType: args.resourceType,
        resourceId: args.resourceId,
    }

    return bulkDownload.definition.url
            .replace('{resourceType}', parsedArgs.resourceType.toString())
            .replace('{resourceId}', parsedArgs.resourceId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AttachmentController::bulkDownload
* @see app/Http/Controllers/AttachmentController.php:133
* @route '/zip-download/{resourceType}/{resourceId}'
*/
bulkDownload.get = (args: { resourceType: string | number, resourceId: string | number } | [resourceType: string | number, resourceId: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bulkDownload.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AttachmentController::bulkDownload
* @see app/Http/Controllers/AttachmentController.php:133
* @route '/zip-download/{resourceType}/{resourceId}'
*/
bulkDownload.head = (args: { resourceType: string | number, resourceId: string | number } | [resourceType: string | number, resourceId: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: bulkDownload.url(args, options),
    method: 'head',
})

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route '/terms'
*/
export const terms = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: terms.url(options),
    method: 'get',
})

terms.definition = {
    methods: ["get","head"],
    url: '/terms',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route '/terms'
*/
terms.url = (options?: RouteQueryOptions) => {
    return terms.definition.url + queryParams(options)
}

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route '/terms'
*/
terms.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: terms.url(options),
    method: 'get',
})

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route '/terms'
*/
terms.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: terms.url(options),
    method: 'head',
})

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route '/privacy-policy'
*/
export const privacyPolicy = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacyPolicy.url(options),
    method: 'get',
})

privacyPolicy.definition = {
    methods: ["get","head"],
    url: '/privacy-policy',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route '/privacy-policy'
*/
privacyPolicy.url = (options?: RouteQueryOptions) => {
    return privacyPolicy.definition.url + queryParams(options)
}

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route '/privacy-policy'
*/
privacyPolicy.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacyPolicy.url(options),
    method: 'get',
})

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route '/privacy-policy'
*/
privacyPolicy.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: privacyPolicy.url(options),
    method: 'head',
})

